import { $tag, TaggedEnumUnion, tagEnum } from '@suntex.core/types';

import { buildStaticContext } from '../utils';

const $ = 'KnowAndShowCategory';

export const KnowAndShowCategory = {
  YakityYak: tagEnum($, 1),
  NumberZoo: tagEnum($, 2),
  YouRule: tagEnum($, 3),
  GetInShape: tagEnum($, 4),
  GetAClue: tagEnum($, 5),
  MissingLinks: tagEnum($, 6),
  PictureThis: tagEnum($, 7),
  WhatsMyAngle: tagEnum($, 8),
  ChancesAre: tagEnum($, 9),
} as const;

export type KnowAndShowCategory = TaggedEnumUnion<typeof KnowAndShowCategory>;

export const $KnowAndShowCategory = buildStaticContext({
  [$tag]: $,
  [KnowAndShowCategory.YakityYak]: {
    value: KnowAndShowCategory.YakityYak,
    slug: 'yakity-yak',
    label: 'Yakity Yak',
    skills: 'Computation and estimation',
  },
  [KnowAndShowCategory.NumberZoo]: {
    value: KnowAndShowCategory.NumberZoo,
    slug: 'number-zoo',
    label: 'Number Zoo',
    skills: 'Numbers, number systems and relationships',
  },
  [KnowAndShowCategory.YouRule]: {
    value: KnowAndShowCategory.YouRule,
    slug: 'you-rule',
    label: 'You Rule!',
    skills: 'Measurement and estimation',
  },
  [KnowAndShowCategory.GetInShape]: {
    value: KnowAndShowCategory.GetInShape,
    slug: 'get-in-shape',
    label: 'Get in Shape',
    skills: 'Geometry',
  },
  [KnowAndShowCategory.GetAClue]: {
    value: KnowAndShowCategory.GetAClue,
    slug: 'get-a-clue',
    label: 'Get a Clue',
    skills: 'Mathematical reasoning, connections and problem solving',
  },
  [KnowAndShowCategory.MissingLinks]: {
    value: KnowAndShowCategory.MissingLinks,
    slug: 'missing-links',
    label: 'Missing Links',
    skills: 'Algebra, functions and calculus',
  },
  [KnowAndShowCategory.PictureThis]: {
    value: KnowAndShowCategory.PictureThis,
    slug: 'picture-this',
    label: 'Picture This',
    skills: 'Statistics and data analysis',
  },
  [KnowAndShowCategory.WhatsMyAngle]: {
    value: KnowAndShowCategory.WhatsMyAngle,
    slug: 'whats-my-angle',
    label: "What's My Angle?",
    skills: 'Trigonometry',
  },
  [KnowAndShowCategory.ChancesAre]: {
    value: KnowAndShowCategory.ChancesAre,
    slug: 'chances-are',
    label: 'Chances Are',
    skills: 'Probability and predictions',
  },
} as const);
